import { Type } from '@angular/core';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { FormFieldModel } from './form-field.model';
import { StyleTypesApiEnum } from '../../../api/styles/enum/style-types-api.enum';
import { DropdownOptionModel } from '../../Forms/models/dropdown-option.model';
import { StyleStateEnum } from '../enums/style-state.enum';

export class LinksStyleFieldModel implements FormFieldModel{
    property: string;
    fieldComponent?: Type<AbstractFormFieldComponent>;
    label?: string;
    description?: string;
    styleType?: StyleTypesApiEnum;
    defaultStyleStateOptions: DropdownOptionModel[] = [
        { label: 'PageBuilder.formField.styles.defaultAgilityStyle', value: StyleStateEnum.DEFAULT },
        { label: 'PageBuilder.formField.styles.custom', value: StyleStateEnum.CUSTOM }
    ];
    changeDefaultStyleStateOptions: (x: any) => DropdownOptionModel[];

    allowExpertMode?: boolean = true;

    constructor(
        property: string,
        fieldComponent?: Type<AbstractFormFieldComponent>,
        label?: string,
        description?: string,
        defaultStyleStateOptions?: DropdownOptionModel[],
        styleType?: StyleTypesApiEnum,
        changeDefaultStyleStateOptions?: (x: any) => DropdownOptionModel[]
    ){
        this.property = property;
        this.fieldComponent = fieldComponent;
        this.label = label;
        this.description = description;
        this.defaultStyleStateOptions = defaultStyleStateOptions;
        this.styleType = styleType;
        this.changeDefaultStyleStateOptions = changeDefaultStyleStateOptions;
    }

}
